import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-suggestions',
    templateUrl: './suggestions.component.html',
    styleUrls: ['./suggestions.component.css'],
    standalone: false
})
export class SuggestionsComponent implements OnInit {
  suggestions: any[] = [];
  createdAt: any[] = [];
  loading = true;
  loaders = Array(10).fill(0);




  constructor(private dashboardService: DashboardService,
              private router: Router) { }

  ngOnInit(): void {
    this.getSuggestions();
  }

  getSuggestions(): void {
    this.dashboardService.getAllSuggestions().subscribe((data) => {
      this.suggestions = data?.response || [];
      this.loading = false;
    }, (err => {
      this.loading = false;
    }));
  }


}
